export const allowedCvFileTypes = [
  'application/pdf',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
];

export const allowedFileTypes = [
  'application/pdf',
  'image/png',
  'image/jpeg',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
];

export const allowedImgTypes = ['image/png', 'image/jpeg', 'image/jpg'];

export const allowedVideoTypes = ['video/mp4'];

// export const allowedDocsTypes = ['application/msword', 'application/pdf'];
export const allowedDocsTypes = ['application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'];
